import { axiosInstance } from "./axios";
import useCustomMutation from "hooks/useCustomMutation";

// Rządowe e-Doręczenia (Poczta Polska UA API + BAE). Konfiguracja skrzynki idzie
// przez settingsService (integracje); tu operacje specyficzne — wyszukiwanie ADE w BAE.

export interface IGovOfficialId {
  /** Rejestr referencyjny: pesel / regon / krs / nip / ue / kppId. */
  ReferenceRegistry?: string;
  Id?: string;
}

export interface IGovAddressSearchRequest {
  /** Kategorie UA: INDIVIDUAL / ADVOCATE / LEGAL_ADVISOR / NOTARY / COMPANY … */
  Categories?: string[];
  EntityName?: string;
  Name?: string;
  Surname?: string;
  OfficialIds?: IGovOfficialId[];
  City?: string;
  PostalCode?: string;
  Street?: string;
  BuildingNumber?: string;
  FlatNumber?: string;
  Offset?: number;
}

export interface IGovAddressSearchResult {
  /** Adres do doręczeń elektronicznych (ADE) odbiorcy. */
  EDeliveryAddress?: string;
  Name?: string;
  Surname?: string;
  EntityName?: string;
  ProfessionalTitle?: string;
  LegalForm?: string;
  IsPublic: boolean;
  /** Adres korespondencyjny sformatowany do wyświetlenia. */
  Address?: string;
  OfficialIds: IGovOfficialId[];
}

export interface IGovAddressSearchResponse {
  Results: IGovAddressSearchResult[];
  TotalResults: number;
}

const searchAddressBook = (
  payload: IGovAddressSearchRequest,
): Promise<{ data: IGovAddressSearchResponse }> =>
  axiosInstance.post("/govEDelivery/searchAddressBook", payload);

const useSearchAddressBook = () => useCustomMutation(searchAddressBook);

export default { useSearchAddressBook };
